const cards = [
  {
    title: '2024暑期档票房TOP10',
    desc: '盘点今年暑期档最卖座的十部电影，从《热辣滚烫》到《封神第二部》，哪部是你心中的年度最佳？',
    image: 'https://readdy.ai/api/search-image?query=Cinema%20box%20office%20concept%20with%20movie%20tickets%20and%20film%20reels%20on%20warm%20golden%20background%2C%20cinematic%20lighting%2C%20elegant%20composition%2C%20soft%20amber%20and%20cream%20tones%2C%20editorial%20photography%20style%2C%20high%20detail&width=600&height=400&seq=card-cinema-01&orientation=landscape',
    tag: '票房盘点',
  },
  {
    title: '悬疑剧天花板：十部必看高分神作',
    desc: '从《漫长的季节》到《隐秘的角落》，国产悬疑剧质量飞跃，这十部高分神作悬疑迷不容错过。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20atmosphere%20with%20dramatic%20lighting%2C%20shadowy%20cinematic%20scene%2C%20warm%20dark%20amber%20tones%2C%20film%20noir%20aesthetic%2C%20suspenseful%20mood%2C%20artistic%20photography%2C%20high%20detail%20composition&width=600&height=400&seq=card-cinema-02&orientation=landscape',
    tag: '悬疑推荐',
  },
  {
    title: '全网综艺大盘点：笑点与泪点齐飞',
    desc: '《奔跑吧》《王牌对王牌》《向往的生活》等王牌综艺最新季热播中，爆笑名场面持续更新。',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20warm%20lighting%2C%20entertainment%20studio%20atmosphere%2C%20cheerful%20vibrant%20scene%2C%20golden%20and%20coral%20accent%20colors%2C%20dynamic%20composition%2C%20professional%20broadcast%20photography%20style%2C%20high%20detail&width=600&height=400&seq=card-cinema-03&orientation=landscape',
    tag: '综艺精选',
  },
  {
    title: '2024年度最受期待的续集大片',
    desc: '《流浪地球3》《封神第三部》《哪吒2》等大片即将来袭，续集能否超越前作？精彩值得期待。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20cinematic%20scene%20with%20dramatic%20clouds%20and%20golden%20light%2C%20grand%20scale%20film%20atmosphere%2C%20warm%20amber%20sunset%20tones%2C%20heroic%20composition%2C%20blockbuster%20movie%20poster%20aesthetic%2C%20high%20detail%20landscape&width=600&height=400&seq=card-cinema-04&orientation=landscape',
    tag: '续集前瞻',
  },
  {
    title: '治愈系动漫推荐：温暖你的闲暇时光',
    desc: '从《间谍过家家》到《葬送的芙莉莲》，精选全网高分治愈动漫，每一部都能治愈你的疲惫心情。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20anime%20style%20illustration%20with%20warm%20soft%20lighting%2C%20gentle%20pastel%20amber%20and%20cream%20colors%2C%20peaceful%20whimsical%20atmosphere%2C%20hand%20drawn%20aesthetic%2C%20comforting%20warm%20tone%20composition%2C%20high%20detail%20artistic&width=600&height=400&seq=card-cinema-05&orientation=landscape',
    tag: '动漫推荐',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3 whitespace-nowrap">
            <i className="ri-layout-grid-line"></i>精选专题
          </span>
          <h2 className="font-heading text-[28px] md:text-4xl text-foreground-950 mb-3">影视专题推荐</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            精心策划的影视专题，发现更多值得看的好内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cards.slice(0, 3).map((card) => (
            <div key={card.title} className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/60 transition-colors">
              <div className="aspect-[3/2] overflow-hidden bg-background-200">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`51影院 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 mb-2 whitespace-nowrap">{card.tag}</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 leading-snug">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {cards.slice(3, 5).map((card) => (
            <div key={card.title} className="bg-background-100 rounded-xl overflow-hidden group cursor-pointer hover:bg-background-200/60 transition-colors flex flex-col sm:flex-row">
              <div className="sm:w-[45%] aspect-[3/2] sm:aspect-auto overflow-hidden bg-background-200 shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  title={`51影院 - ${card.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700 mb-2 whitespace-nowrap self-start">{card.tag}</span>
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-2 leading-snug">{card.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{card.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}